import axios from 'axios';

// 삼성 브라우저 감지
const isSamsungBrowser = /SamsungBrowser/i.test(navigator.userAgent);

// 사설 IP 대역 확인 함수
const isPrivateIP = (ip) => {
  const privateRanges = [
    /^10\./,                    // 10.0.0.0/8
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./, // 172.16.0.0/12
    /^192\.168\./,              // 192.168.0.0/16
    /^127\./,                   // 127.0.0.0/8 (localhost)
  ];
  return privateRanges.some(range => range.test(ip));
};

// 동적 API URL 설정 함수
const getApiBaseURL = () => {
  // 현재 호스트 정보 가져오기
  const currentHost = window.location.hostname;
  const currentPort = window.location.port;
  const currentProtocol = window.location.protocol;
  
  // console.log('Current location:', { currentHost, currentPort, currentProtocol });
  
  // 프로덕션 도메인으로 접속한 경우
  if (currentHost === 'goguma.org' || currentHost === 'www.goguma.org') {
    // 환경 변수가 설정되어 있으면 사용, 없으면 같은 origin 사용
    if (process.env.REACT_APP_API_URL) {
      // console.log('Using production API URL:', process.env.REACT_APP_API_URL);
      return process.env.REACT_APP_API_URL;
    } else {
      // console.log('Using same origin for production');
      return ''; // 같은 origin 사용
    }
  }
  
  // localhost로 접속한 경우 - 로컬 개발 환경
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    const baseURL = 'http://localhost';
    // console.log('Using localhost URL:', baseURL);
    return baseURL;
  }
  
  // IP 주소로 접속한 경우
  if (/^\d+\.\d+\.\d+\.\d+$/.test(currentHost)) {
    // 사설 IP인 경우에만 허용 (보안상 안전)
    if (isPrivateIP(currentHost)) {
      const baseURL = `${currentProtocol}//${currentHost}`;
      // console.log('Using private IP-based URL:', baseURL);
      return baseURL;
    } else {
      // 공인 IP로 접속한 경우 프로덕션 도메인으로 리다이렉트
      console.warn('Public IP access detected, redirecting to production domain');
      window.location.href = 'https://goguma.org';
      return 'https://goguma.org';
    }
  }
  
  // 기본값 - 프로덕션 도메인 사용
  // console.log('Using default production URL');
  return 'https://goguma.org';
};

const api = axios.create({
  baseURL: getApiBaseURL(),
  timeout: 120000, // 계좌 잔고 조회 타임아웃을 120초로 증가
  headers: {
    'Content-Type': 'application/json',
    ...(isSamsungBrowser && {
      'X-Requested-With': 'XMLHttpRequest' // 삼성 브라우저 호환성
    })
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      // 현재 URL 저장: 로그인 후 원래 페이지로 돌아오기 위함
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath && currentPath !== '/sign-in' && currentPath !== '/sign-up') {
        sessionStorage.setItem('redirectAfterLogin', currentPath);
      }
      window.location.href = '/sign-in';
    }
    return Promise.reject(error);
  }
);

export default api;
